export default __webpack_public_path__ + "static/poseidon-undersea-resort-43b57720e219d4efc0ee26fcb10baecb.jpg";